export enum Type {
  Ride = 'RIDE',
  Event = 'EVENT',
  OnlineEvent = 'ONLINE_EVENT',
}
